module.exports = __webpack_public_path__ + "static/media/PPT.bfa2d1aa.svg";